import { FiX } from "react-icons/fi";
import { IconType } from "react-icons";
import ProgressStepper from "./ProgressStepper";

interface ScheduleModalHeaderProps {
  title: string;
  subtitle: string;
  currentStep: number;
  totalSteps: number;
  steps: Array<{ number: number; label: string; icon: IconType }>;
  accentColor: string;
  textColor: string;
  backgroundColor?: string;
  showStepper: boolean;
  onClose: () => void;
}

function ScheduleModalHeader({
  title,
  subtitle,
  currentStep,
  totalSteps,
  steps,
  accentColor,
  textColor,
  backgroundColor,
  showStepper,
  onClose,
}: ScheduleModalHeaderProps) {
  return (
    <div className="relative border-b border-stroke px-4 sm:px-6 py-4 dark:border-strokedark">
      <button
        type="button"
        onClick={onClose}
        className="absolute right-4 top-4 rounded-full p-2 text-gray-500 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
      >
        <FiX size={20} />
      </button>

      <div className="pr-12">
        <h3 className="text-lg sm:text-xl font-semibold text-black dark:text-white">
          {title}
        </h3>
        <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1">
          {subtitle}
        </p>
      </div>

      {showStepper && (
        <ProgressStepper
          steps={steps}
          currentStep={currentStep}
          accentColor={accentColor}
          textColor={textColor}
          backgroundColor={backgroundColor}
        />
      )}
    </div>
  );
}

export default ScheduleModalHeader;
